export const NON_DEFAULT_FILTERS = ['search_location', 'search_category'];

export const NON_RESETTABLE_FILTERS = ['search_location', 'search_category', 'sort'];

export enum CUSTOM_FILTERS {
    MAKE = 'vehicle_make',
    MODEL = 'vehicle_model',
    PRICE = 'price',
    CATEGORIES = 'search_category',
    SORT = 'sort',
}

export const EXPANDED_FILTERS = [
    'vehicle_make',
    'vehicle_model',
    'price',
    'vehicle_registration_year',
    'vehicle_mileage',
    'job_contract_type',
    'recruiter_type',
    'job_hours',
    'property_type',
    'property_room_type',
    'property_couples',
    'seller_type',
    'property_number_beds',
    'salary',
];

export const DEFAULT_FILTER_LABEL = 'Any';
